import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import profile from '../data/profile';

function Footer() {
  const { name } = profile;
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 3, md: 4 },
        backgroundColor: '#0C0B0A',
        borderTop: '1px solid rgba(234,227,214,0.06)',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: '0.82rem', md: '0.88rem' },
            textAlign: 'center',
            color: '#524A42',
            letterSpacing: '0.01em',
          }}
        >
          {currentYear} {name}
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
